import React, { Fragment, useState, useEffect } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import CustomPagination from "../../pagination/Pagination";
import { useHistory } from "react-router-dom";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";
import Loader from "react-loader-spinner";
import "../../admin/StudentProgress/StudentProgress.css";
import "./GoalCriteriaOrSetup.css";

const RequiredCourseSet = () => {
  let history = useHistory();
  const [requiredCourseData, setRequiredCourseData] = useState();
  const [coursePageData, setCoursePageData] = useState();
  const [page, setPage] = useState(1);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [deletedCourseId, setDeletedCourseId] = useState();
  const [loading, setLoading] = useState(false);
  const [publishedButtonIndex, setPublishedButtonIndex] = useState(-1);
  const [publishedLoading, setPublishedLoading] = useState(false);

  const getCourseData = () => {
    setLoading(true);
    let obj = {
      page: page,
      role: "school_it",
      school: user?.school_id
    };
    GetStudentService.coursePage(obj)
    .then((data) => {
      setCoursePageData(data?.data);
      setRequiredCourseData(data?.data);
      let convertedData = DataMapping(data?.data?.result);
      if (convertedData?.length > 0) {
        setConvertedDataToCoursepageData(convertedData);
      }
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const DataMapping = (value) => {
    for (var i = 0; i < value.length; i++) {
      for (var j = 0; j < value[i].publish_data.length; j++) {
        if (value[i].publish_data[j].school_id === user.school_id) {
          value[i].published = value[i].publish_data[j].published;
          value[i].data = value[i].publish_data[j].data_mapped_percentage;
        }
      }
    }
    return value;
  };

  const setConvertedDataToCoursepageData = (data) => {
    if (data) {
      setCoursePageData({ ...coursePageData, result: data });
    }
  };

  const viewSingleCourse = (value) => {
    history.push(`/school_it/course/${value?.id}`);
  };

  const mapCourseDataHandler = (value) => {
    history.push(`/school_it/mapcourse/${value?.id}`);
  };

  const deleteCourseRequirementhandler = (item) => {
    const courseId = item?.id;
    setDeletedCourseId(courseId);
    let obj = {
      course_id: courseId
    };
    GetStudentService.deleteCourseRequirement(obj)
    .then(async () => {
      const confirmed = await swal({
        title: "Delete?",
        text: "Are you sure you want to delete?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "OK"
        },
        dangerMode: true,
        closeOnClickOutside: false
      });
      if (confirmed) {
        deleteCourseAfterRequirement(courseId);
      }
    })
    .catch(() => {});
  };

  const deleteCourseAfterRequirement = (courseId = deletedCourseId) => {
    let obj = {
      deleted: true
    };
    GetStudentService.deleteCourse(obj)
    .then((_data) => {
      courseDeleteConfirmation(courseId);
    })
    .catch(() => {});
  };

  const deleteUndoCourse = () => {
    let obj = {
      deleted: true
    };
    GetStudentService.deleteCourse(obj)
    .then((_data) => {
    })
    .catch(() => {});
  };

  const courseDeleteConfirmation = (value) => {
    let obj = {
      delete_course_id: value
    };
    GetStudentService.deleteCourseConfirmation(obj)
    .then((_data) => {
      setDeletedCourseId();
      getCourseData();
    })
    .catch(() => {});
  };

  const undoDelete = (value) => {
    let obj = {
      course_id: value?.id,
      deleted: "True"
    };
    GetStudentService.undoCourseDelete(obj)
    .then((_data) => {
      getCourseData();
    })
    .catch(() => {});
  };

  useEffect(() => {
    deleteUndoCourse();
    getCourseData();
  }, [page]);


  const publishOrUnpublishCourse = (item, index, publishValue) => {
    setPublishedLoading(true);
    setPublishedButtonIndex(index);
    let obj = {
      course_id: item?.id,
      published: publishValue,
      school: user?.school_id
    };
    GetStudentService.goalPublish(obj)
    .then((_data) => {
      calculateGoalPublish(obj);
    })
    .catch((_error) => {
      setPublishedLoading(false);
    });
  };

  const handleDuplicateCourse = (item) => {
    let obj = {
      clone_id: item?.id,
      school: user?.school_id
    };
    GetStudentService.duplicateCourse(obj)
    .then((data) => {
      history.push(`/school_it/course/${data?.data?.new_id}`);
    })
    .catch(() => {});
  };

  const handleCourseEdit = (item) => {
    history.push(`/school_it/course/${item?.id}`);
  };

  const calculateGoalPublish = (value) => {
    GetStudentService.calculateGoalPublish(value)
    .then((_data) => {
      getCourseData();
      swal({
        text: "This Goal/Course has been used by a counselor. Cannot be unpublished.",
        icon: "warning",
        buttons: {
          confirm: true
        },
        closeOnClickOutside: false
      });
      setPublishedLoading(false);
    })
    .catch((_error) => {
      setPublishedLoading(false);
    });
  };



  const renderPublishSpinner = (index) =>
  publishedButtonIndex === index && publishedLoading ?
  <Loader type="TailSpin" color="white" height={16} width={16} /> :
  null;

  return (
    <Fragment>
      <div className="admin-ccplus-panel-header">
        <div>
          <h2 className="admin-ccplus-panel-title">Required Course Set</h2>
          <p className="admin-ccplus-panel-hint">
            Create, publish, and map course requirements
          </p>
        </div>
        <button
          type="button"
          onClick={() => history.push("/school_it/course/")}
          className="admin-ccplus-btn primary toolbar">

          New Required Course Set
        </button>
      </div>

      {loading ?
      <div className="admin-ccplus-list-loading">
          <CustomLoader variant="inline" color="#007bff" size={42} />
        </div> :

      <div className="admin-ccplus-list">
          {coursePageData?.result?.length > 0 ?
        coursePageData.result.map((item, index) =>
        <div
          key={item?.id || index}
          className={`admin-ccplus-item ${item?.deleted ? "is-deleted" : ""}`}>

                <div className="admin-ccplus-item-main">
                  <p className="admin-ccplus-item-name">{item?.name}</p>
                  <div className="admin-ccplus-item-meta">
                    {item?.deleted ?
              <span className="admin-ccplus-badge deleted">Deleted</span> :
              item?.published === true ?
              <span className="admin-ccplus-badge broadcast">Published</span> :

              <span className="admin-ccplus-badge conceal">Unpublished</span>}

                    <span className="school-it-ccplus-mapping">
                      Data Mapping: {item?.data === "" || item?.data == null ? "0" : item?.data}%
                    </span>
                  </div>
                </div>

                <div className="admin-ccplus-item-actions">
                  {item?.deleted === true &&
            <button
              type="button"
              onClick={() => undoDelete(item)}
              className="admin-ccplus-btn danger">

                      Undo
                    </button>}


                  {item?.deleted === false && (
            item?.published === "" || item.published === false) &&
            <button
              type="button"
              onClick={() =>
              publishOrUnpublishCourse(item, index, "True")}

              disabled={item?.data < 100 || item?.data == null}
              className="admin-ccplus-btn broadcast">

                        Publish
                        {renderPublishSpinner(index)}
                      </button>}


                  {item?.deleted === false && item.published === true &&
            <button
              type="button"
              onClick={() =>
              publishOrUnpublishCourse(item, index, "False")}

              className="admin-ccplus-btn conceal">

                      UnPublish
                      {renderPublishSpinner(index)}
                    </button>}


                  {item?.deleted === false &&
            <button
              type="button"
              className="admin-ccplus-btn primary"
              onClick={() => handleDuplicateCourse(item)}>

                      Duplicate
                    </button>}


                  {item?.deleted === false &&
            <button
              type="button"
              onClick={() => mapCourseDataHandler(item)}
              className="admin-ccplus-btn secondary">

                      Map Data
                    </button>}


                  {item?.is_global && item?.deleted === false &&
            <button
              type="button"
              onClick={() => viewSingleCourse(item)}
              className="admin-ccplus-btn secondary">

                      View
                    </button>}


                  {item?.is_global === false && item?.deleted === false &&
            <button
              type="button"
              onClick={() => handleCourseEdit(item)}
              className="admin-ccplus-btn secondary">

                      Edit
                    </button>}


                  {item?.is_global === false && item?.deleted === false &&
            <button
              type="button"
              onClick={() => deleteCourseRequirementhandler(item)}
              className="admin-ccplus-btn primary">

                      Delete
                    </button>}

                </div>
              </div>
        ) :

        <p className="admin-ccplus-empty">No required course sets found</p>}

        </div>}


      <div className="admin-ccplus-pagination">
        <CustomPagination
          count={requiredCourseData}
          pageValue={page}
          setPage={setPage} />

      </div>
    </Fragment>);

};

export default RequiredCourseSet;